var _a, _b;
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { v4 as uuid } from 'uuid';
import { emburseLoginEnabled, getCompanyIdFromUrl } from '@ReactComponents/Login/loginHelper';
import { LoginPage } from '@ReactComponents/Login/LoginPage';
import { AbacusEmbarkProvider } from '@Shared/AbacusEmbarkProvider';
import '../utils/castle';
function redirectToAccounts() {
    var _a;
    const wc = window.whitelabelConfiguration;
    let href = `${wc.account_url}authorize?response_type=id_token` +
        `&client_id=${wc.account_client_id}&redirect_uri=${wc.host}/login/oidc/assertion` +
        `&scope=openid%20email%20licenses&nonce=${uuid()}`;
    const companyId = getCompanyIdFromUrl((_a = window.location) === null || _a === void 0 ? void 0 : _a.search);
    if (companyId) {
        href += `&bu_customer_id=${companyId}`;
    }
    window.location.href = href;
}
// reset sidebar expanded menu states
sessionStorage.removeItem('expandedMenuIds');
if (((_a = window.FEATURES) === null || _a === void 0 ? void 0 : _a.emburse_login) && emburseLoginEnabled((_b = window.location) === null || _b === void 0 ? void 0 : _b.search)) {
    redirectToAccounts();
}
// Set the public path for webpacked assets
// https://webpack.js.org/guides/public-path/
__webpack_public_path__ = window.webpack_public_path;
ReactDOM.render(_jsx(AbacusEmbarkProvider, { children: _jsx(LoginPage, { csrf: window.csrf, locals: window.errors }) }), document.querySelector('#app'));
